import { DayOfTheWeek, RecurrenceScheduleType } from "@api/graphql/generated/generated-types";

export const FREQUENCY_OPTIONS = [
  { id: RecurrenceScheduleType.Daily, label: "Daily" },
  { id: RecurrenceScheduleType.CustomDaysOfTheWeek, label: "Custom Days of the Week" },
  { id: RecurrenceScheduleType.CustomDaysOfTheMonth, label: "Custom Days of the Month" },
  { id: RecurrenceScheduleType.Biweekly, label: "Biweekly" },
  { id: RecurrenceScheduleType.MonthlyOnFirst, label: "Monthly On First" },
  { id: RecurrenceScheduleType.MonthlyOnSecond, label: "Monthly On Second" },
  { id: RecurrenceScheduleType.MonthlyOnThird, label: "Monthly On Third" },
  { id: RecurrenceScheduleType.MonthlyOnFourth, label: "Monthly On Fourth" },
  { id: RecurrenceScheduleType.MonthlyOnLast, label: "Monthly On Last" },
  { id: RecurrenceScheduleType.MonthlyOnFifthWeek, label: "Monthly On Fifth Week (if applicable)" },
  { id: RecurrenceScheduleType.ManualOnly, label: "Manual" },
];

export const DAY_LABEL: Record<DayOfTheWeek, string> = {
  [DayOfTheWeek.Mon]: "Mon",
  [DayOfTheWeek.Tue]: "Tue",
  [DayOfTheWeek.Wed]: "Wed",
  [DayOfTheWeek.Thu]: "Thu",
  [DayOfTheWeek.Fri]: "Fri",
  [DayOfTheWeek.Sat]: "Sat",
  [DayOfTheWeek.Sun]: "Sun",
};

export const WEEK_DAY_ORDER = Object.keys(DAY_LABEL) as DayOfTheWeek[];

export const MONTHLY_ON_NTH_TYPES = new Set([
  RecurrenceScheduleType.MonthlyOnFirst,
  RecurrenceScheduleType.MonthlyOnSecond,
  RecurrenceScheduleType.MonthlyOnThird,
  RecurrenceScheduleType.MonthlyOnFourth,
  RecurrenceScheduleType.MonthlyOnLast,
  RecurrenceScheduleType.MonthlyOnFifthWeek,
]);

export const WEEK_BASED_TYPES = new Set([
  RecurrenceScheduleType.CustomDaysOfTheWeek,
  RecurrenceScheduleType.MonthlyOnFirst,
  RecurrenceScheduleType.MonthlyOnSecond,
  RecurrenceScheduleType.MonthlyOnThird,
  RecurrenceScheduleType.MonthlyOnFourth,
  RecurrenceScheduleType.MonthlyOnLast,
  RecurrenceScheduleType.MonthlyOnFifthWeek,
]);
